module.exports = __webpack_public_path__ + "5e2fc72439e5a8d40399dfb9ed2bea72.png";